import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/mac/github/elemental-zcash/react/docs/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Theming in Elemental Design System is possible with a theme object that defines your application’s colors, spacing, fonts, breakpoints and more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      